import { getSessionId, saveSessionId } from './storage';

export const generateSessionId = (waitingRoomId) => {
    const base = Math.random().toString(36).substring(2, 12) + Math.random().toString(36).substring(2, 12);
    return waitingRoomId ? `${waitingRoomId}_${base}` : base;
};

export const handleSessionId = (waitingRoomId) => {
    if (!waitingRoomId) {
        return generateSessionId();
    }

    const sessionId = getSessionId(waitingRoomId);
    if (sessionId) {
        return sessionId;
    }

    const generatedSessionId = generateSessionId(waitingRoomId);
    saveSessionId(generatedSessionId, waitingRoomId);
    return generatedSessionId;
};

// eslint-disable-next-line no-undef
export const getIdFromUrl = () => window.location.pathname.split('/').pop();

export const getWaitingRoomParamsFromUrl = () => {
    // eslint-disable-next-line no-undef
    const url = new URL(window.location.href);
    return {
        eventId: url.searchParams.get('eventId'),
        token: url.searchParams.get('token'),
        language: url.searchParams.get('language'),
    };
};

export const modifyUrlAfterTokenValidation = (eventId) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    url.searchParams.set('eventId', eventId);
    window.history.replaceState({}, '', `${url.pathname}?${url.searchParams.toString()}`);
};
